import React, { Component } from "react";
import { ChangeTitle } from "../util/ChangeTitle";
import "./footer.css"
import { Helmet } from "react-helmet";
export default class Footer extends Component {
  render() {
    ChangeTitle("Footer");
    return (
      <div class="container-fluid">
        <Helmet>
          <script src="https://static-bundles.visme.co/forms/vismeforms-embed.js"></script>
          <script async data-id="7341118552" id="chatling-embed-script" type="text/javascript" src="https://chatling.ai/js/embed.js"></script>
        </Helmet>
        <div class="row">
          <center>
            <div class="col-lg-5 col-md-6 footer-newsletter" align="center">
        

    
    
            </div>
          </center>
        </div>
      </div>
    );
  }
}
